import { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Context from "../../Context";

function ScrollToTop({ history }) {
  const { setMenuOpen } = useContext(Context);
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
      setMenuOpen(false);
    });
    return () => {
      unlisten();
    }
  }, [history]);

  return (null);
}

export default withRouter(ScrollToTop);